<template>
  <div id="userLayout" :class="['user-layout-wrapper', device]">
    <div class="container">
      <div  id="containerbox" class="container-box">
        <!-- <div class="top">
          <div class="header">
            <a href="/">
              <img src="~@/assets/logo.png" class="logo" alt="logo" />
              <span class="title">金牌厨柜GIS管理系统</span>
            </a>
          </div>
          <div class="desc">金牌厨柜GIS管理系统</div>
        </div> -->
        <p  class="top-p-title"  >金牌厨柜GIS管理系统</p>
        <route-view></route-view>

        <!-- <div class="footer">
        <div class="links">
          <a href="https://www.canc.com.cn/" target="_blank">帮助</a>
          <a href="###" target="_blank">隐私</a>
          <a href="###" target="_blank">条款</a>
        </div>
        <div class="copyright">
          Copyright &copy; 2020 <a href="https://www.canc.com.cn/" target="_blank">金牌厨柜效能信息部</a> 出品
        </div>
        </div>-->
      </div>
      <div  class="container-logo"  >
        <img class="container-logo-image" src="~@/assets/logo-white.png"  />
        <h3  class="container-logo-h3"  >金牌厨柜</h3>
      </div>
    </div>
  </div>
</template>

<script>
import RouteView from '@/components/layouts/RouteView'
import { mixinDevice } from '@/utils/mixin.js'
import ImagPreview from '../../views/jeecg/ImagPreview.vue'

export default {
  name: 'UserLayout',
  components: { RouteView,ImagPreview },
  mixins: [mixinDevice],
  data() {
    return {}
  },
  mounted() {
    document.body.classList.add('userLayout')
  },
  beforeDestroy() {
    document.body.classList.remove('userLayout')
  },
}
</script>

<style lang="less" scoped>
#userLayout.user-layout-wrapper {
  height: 100%;
  .container {
      width: 100%;
      min-height: 100%;
      //   background: #f0f2f5 url(~@/assets/background.svg) no-repeat 50%;
      //   background-size: 100%;
      background: url(~@/assets/05.png);
      background-size: 100% 100%;
      position: relative;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      .container-box {
        width: 550px;
        height: 527px;
        position: absolute;
        padding: 35px 70px 32px 65px;
        background: url(~@/assets/loginpanel2.png);
        background-repeat: no-repeat;
        background-clip:border-box;
        background-size:contain;
      }
      .top-p-title{
        font-size: 33px;
        font-weight: 400;
        color: #58acb8;
        margin-bottom: 0.2rem !important;
        position: relative;
        bottom: -13px;
      }
      .container-logo{
        width: 246px;
        height: 57px;
        position: absolute;
        right: 1%;
        top: 1%;
        color:white;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .container-logo-image{
          width: 70px;
          height: auto;
        }
        .container-logo-h3{
          color: white;
          font-size: 40px;
          margin: 0px;
          padding: 0px;
        }
      }
      a {
        text-decoration: none;
      }
    }
  @media only screen and (max-width: 479px) {
    .container{
      .container-box {
        width: 100%;
        padding: 15px 20px 20px 15px;
      }
      .top-p-title{
        font-size: 40px;
        font-weight: 400;
        color: #58acb8;
      }
      background: #0D122F;
    }
  }
  @media only screen and (min-width: 480px){
    .container{
      .container-box {
        right: 7%;
      }
    }
  }
}
</style>